import { ReactElement, useEffect } from 'react';
import { Helmet } from 'react-helmet';

// Components
import { Cta, Hero } from 'components';

// Hooks.
import { useLoadEvent } from 'hooks';

// Styles
import styles from './HomePage.module.scss';

export const HomePage = (): ReactElement => {
  const fireLoadEvent = useLoadEvent({ PageType: 'Main Page' });

  useEffect(() => {
    fireLoadEvent();
  }, [fireLoadEvent]);

  return (
    <>
      <Helmet>
        <title>Homepage</title>
      </Helmet>
      <section className={styles.section}>
        <Hero />
        <Cta />
      </section>
    </>
  );
};
